import { FilterField, labelId } from 'kontrolEdge/helpers/advancedFilters';
import type { Connector, Route } from '../../backbone.types';

export const BGP_SESSION_TABLE_HEADERS = [
    'Status',
    'Label',
    'VRF',
    'Peer IP',
    'Local IP',
    'Local ASN',
    'Rx',
    'Tx',
    'Limit',
    'Detail',
];

export function makeBgpSessionFields(): FilterField<Connector>[] {
    const fields: FilterField<Connector>[] = [
        {
            label: 'Status',
            key: 'status',
            accessor: (r) => (r.bgp === 'Established' ? 'Up' : 'Down'),
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Label',
            key: 'label',
            accessor: (r) => r.label,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Ref',
            key: 'ref',
            accessor: (r) => r.ref,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'VRF',
            key: 'vrf',
            accessor: (r) => r.vrf,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Peer IP',
            key: 'peerip',
            accessor: (r) => r.peerIp,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Local IP',
            key: 'localip',
            accessor: (r) => r.ip,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'Local ASN',
            key: 'localasn',
            accessor: (r) =>
                r.localAsn != null && Number.isFinite(r.localAsn)
                    ? String(r.localAsn)
                    : '',
            type: 'string',
            inFreeText: true,
        },
    ];
    for (const f of fields) f.key ??= labelId(f.label);
    return fields;
}

/** Suggested keys for BGP route list search (modal Routes tab). */
export const BGP_MODAL_ROUTE_SEARCH_KEYS = [
    'Prefix',
    'LP',
    'MED',
    'AS path',
];

export function makeBgpRouteFields(): FilterField<Route>[] {
    const fields: FilterField<Route>[] = [
        {
            label: 'Prefix',
            key: 'prefix',
            accessor: (r) => r.pfx,
            type: 'string',
            inFreeText: true,
        },
        {
            label: 'LP',
            key: 'lp',
            accessor: (r) => r.lp,
            type: 'number',
            inFreeText: true,
        },
        {
            label: 'MED',
            key: 'med',
            accessor: (r) => r.med,
            type: 'number',
            inFreeText: true,
        },
        {
            label: 'AS path',
            key: 'aspath',
            accessor: (r) => r.asp,
            type: 'string',
            inFreeText: true,
        },
    ];
    for (const f of fields) f.key ??= labelId(f.label);
    return fields;
}
